import React from 'react';
import { Button } from '../../../components/ui/button';
import { Label } from '../../../components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../../components/ui/select';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../../../components/ui/dialog';
import { MONTHS_RO } from './constants';

export const GenerateDialog = ({ open, onOpenChange, genMonth, setGenMonth, onGenerate, generating, equipmentName }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-sm">
      <DialogHeader><DialogTitle className="text-base">Genereaza intrari luna</DialogTitle></DialogHeader>
      <p className="text-xs text-slate-500">
        Se genereaza intrari pentru <strong>{equipmentName}</strong> pentru fiecare tip de intretinere activ.
      </p>
      <div>
        <Label className="text-xs">Luna</Label>
        <Select value={genMonth} onValueChange={setGenMonth}>
          <SelectTrigger className="h-9 text-sm"><SelectValue /></SelectTrigger>
          <SelectContent>{MONTHS_RO.map((m, i) => <SelectItem key={i} value={String(i + 1)}>{m}</SelectItem>)}</SelectContent>
        </Select>
      </div>
      <DialogFooter>
        <Button variant="outline" size="sm" onClick={() => onOpenChange(false)}>Anuleaza</Button>
        <Button size="sm" onClick={onGenerate} disabled={generating} data-testid="confirm-generate-btn">
          {generating ? 'Se genereaza...' : 'Genereaza'}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
